import React, {useEffect, useState} from 'react';
import Link from 'next/link';

import SimpleShippingInformation from './simpleShippingInformation';
import {
    calculateShippingInformation,
    getGrossPriceString, getJowuaProductRoute, handleRouteToJowuaProduct,
} from '../../lib/utils/productUtils';
import ContainedButton from '../buttons/containedButton';
import {useRouter} from 'next/router';
import {getFinalStockInformation} from '../../lib/utils/selectorUtils';
import _ from 'lodash';
import {useTranslation} from 'next-i18next';
import {EmblaGallery} from './EmblaGallery';
import {parseToPriceString} from "../../lib/utils/priceUtils";

export default function VariationProduct({item, priority = false}) {

    const {t: translateCommon} = useTranslation('common');
    const {t: translatePages} = useTranslation('pages');

    const {push, asPath, locale} = useRouter();
    const [productInformation, setProductInformation] = useState({
        galleryUrls: [],
        mainProduct: null,
        priceString: "",
        salePriceString: ""
    })

    const {id, variationProduct} = item;
    const {
        id: variationProductId,
        simpleProducts,
        slug,
        title,
        shortTitle,
        simpleProductInformation,
        isConsultationProduct
    } = variationProduct;

    useEffect(() => {

        const [mainProduct] = simpleProducts;
        let priceString = ""
        let salePriceString = ""
        const {price} = mainProduct;
        const {netPrice, tax, currency, inSale} = price;
        const {taxPercent} = tax;

        let salePrice = null;

        if (!!inSale && !!price.salePrice)
            salePrice = price.salePrice;

        salePriceString = !!salePrice ?
            getGrossPriceString(salePrice, taxPercent) :
            '';
        priceString = getGrossPriceString(netPrice, taxPercent);


        setProductInformation({
            galleryUrls: _.uniqBy([mainImage].concat(gallery), 'id'),
            mainProduct: isConsultationProduct ? null : mainProduct,
            priceString,
            salePriceString
        })


    }, [])

    const {mainImage, gallery} = simpleProductInformation;

    const shippingInformation = getFinalStockInformation(simpleProducts.map(
        ({stocks}) => calculateShippingInformation(stocks)));

    const productUrl = !!isConsultationProduct? `${asPath}/product/${slug}` : getJowuaProductRoute(variationProduct, locale);

    const handleOnClickMoreAbout = async (e) => {

        e.preventDefault();
        await push(productUrl);

        // if (!!isConsultationProduct) {
        //     await push(`${asPath}/product/${slug}`);
        // } else {
        //     await handleRouteToJowuaProduct(e, variationProduct, locale);
        // }


    };
    const slides = Array.from(Array(10).keys());
    return (
        <div key={item.id}
             className="w-full flex flex-col gap-5 items-center border-b pb-8 md:border-0 md:pb-0">

            <div className={'w-72 b-72 bg-gray-800'}/>

            <EmblaGallery pictures={productInformation.galleryUrls}
                          priority={false}
                          lazy={true}
                          width={'w-72'}
                          height={'h-72'}
                          showThumbnails={false}
                          routeToProductOnClick={true}
                          productUrl={productUrl}
            />


            <Link href={productUrl}>
                <a>
                    <h2 className={'font-title uppercase text-black text-center h-8'}>{shortTitle}</h2>
                </a>
            </Link>

            <p className={''}>
                <div>

                    {
                        isConsultationProduct ? <span>{translatePages('CATEGORY.FROM_PRICE', {
                            price: productInformation.priceString,
                        })}</span> : !!productInformation.salePriceString ? <p>
                                <del>{productInformation.priceString}</del>
                                <span>{productInformation.salePriceString}</span>
                            </p>
                            :
                            <span>{productInformation.priceString}</span>
                    }


                </div>


            </p>
            <center>
                <SimpleShippingInformation stockInformation={shippingInformation}
                                           showShippingDays={true}/>
            </center>

            <ContainedButton size={'sm'}
                             onClick={handleOnClickMoreAbout}> {translateCommon(
                'MORE_ABOUT')} </ContainedButton>


        </div>
    );
}
